

















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component
export default class Progressbar extends Vue {
  @Prop({default: 0}) private value !: number
  @Prop({default: 'primary'}) private color !: string
}
